import localForage from 'localforage';
import LocalForage from 'localforage';

export function getAuthStorageEngine(): LocalForage {
	return localForage;
}
